import { render, staticRenderFns } from "./storeInformationfenxi.vue?vue&type=template&id=7195798a&scoped=true&"
import script from "./storeInformationfenxi.vue?vue&type=script&lang=js&"
export * from "./storeInformationfenxi.vue?vue&type=script&lang=js&"
import style0 from "./storeInformationfenxi.vue?vue&type=style&index=0&id=7195798a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7195798a",
  null
  
)

export default component.exports